import { useTranslation } from 'react-i18next';

import { Vulnerability } from 'api/encounters/types';

const ConnectedVulnerabilitiesPopup: React.FC<{
  vulnerabilities: Vulnerability[];
  slug: string;
  encounterId: number;
}> = ({ vulnerabilities, slug, encounterId }) => {
  const { t } = useTranslation();
  const handleButtonClick = () => {
    const url = `/r/object/vulnerabilities/${slug}?connected_to_enc=${vulnerabilities.map(vul => vul.id).join(',')}&encounter_id=${encounterId}`;
    window.open(url, '_blank');
  };

  return (
    <>
      <button
        className="btn btn-ghost-info btn-sm d-flex align-items-center gap-2 cursor-pointer"
        onClick={handleButtonClick}
        type="button"
      >
        {t('ObjectEncs.associated_pccs')} ({vulnerabilities.length})
      </button>
    </>
  );
};

export default ConnectedVulnerabilitiesPopup;
